import { useState, useRef } from 'react'
import ReactPlayer from 'react-player'
import {
    Box, Center, VStack, HStack, Button, Spinner, Input, InputGroup, InputRightElement, useToast, useClipboard
  } from '@chakra-ui/react';
import {useWeb3React } from "@web3-react/core"
import {ethers} from 'ethers'
import nfts from '../lib/nfts'
import {toBN} from '../lib/bn'

const SendNFT = (props) => {
    const {account, library} = useWeb3React()
    const toast = useToast()
    const toastIdRef = useRef()
    const [sendTo,setSendTo] = useState('')
    const [processing, setProcessing] = useState(false)

    const send = async () => {
        setProcessing(true)
        toastIdRef.current = toast({
            title: 'Send to ' + sendTo + ' pending',
            status: 'info',
            isClosable: true,
            duration: 120000
        })
        try{
            let tx = await nfts.yieldToken.purchaseTransfer(library.getSigner(account),toBN(props.tokenId),sendTo)
            //let tx = await nfts.yieldToken.transferFrom(library.getSigner(account),account,sendTo,toBN(props.tokenId))
            toast.update(toastIdRef.current,{
                title: 'Sent tx to blockchain. Awaiting confirmation',
                status: 'info',
                isClosable: true,
                duration: 120000
            })
            await nfts.confirm(tx.hash)
            toast.update(toastIdRef.current,{
                title: 'Send successful',
                status: 'success',
                isClosable: true,
                duration: 2000
            })
            setProcessing(false)
            setSendTo('')
            setTimeout(()=>{
                props.back()
                setProcessing(false)
            },2000)
        }
        catch(e){
            toast.update(toastIdRef.current,{
                title: e.message,
                status: 'error',
                isClosable: true,
                duration: 2000
            })
            setProcessing(false)
        }

    }

    let isLoading = !(props.tokenId && props.tokenId!==-1)
    return (
        <div style={{marginTop: 20}}>
            <HStack>
                <div style={{height: 520, width: 420, borderRadius: 10, overflow: 'hidden', boxShadow: '5px 5px 15px 5px rgba(156,156,156,0.3)'}}>
                    <ReactPlayer url={props.meta.animation_url} playing loop height={530} width={450} style={{position: 'relative', left: -5, top: -5}} />
                </div>
                <div style={{ height: 535, width: 380, padding: 10}}>
                    <div style={{marginLeft: 20, marginTop: 20, color: '#1f82e2', cursor: 'pointer'}}  onClick={props.back}>Back to Admin Page</div>
                    <div style={{fontSize: 30, fontWeight: 'bold', marginLeft: 20, marginTop: 10}}>{props.meta.name}</div>
                    <div style={{marginLeft: 20, marginTop: 10}}>{props.meta.description}</div>
                    {isLoading && <div style={{marginLeft: 20, marginTop: 10}}>Finding next available TokenId <Spinner size='xs'/></div>}
                    {!isLoading && 
                    <>
                        <div style={{marginLeft: 20, marginTop: 15, fontSize: 12}}>TokenId: {props.tokenId}</div>
                        <div style={{marginLeft: 20, marginTop: 10}}>
                            <InputGroup size='md'>
                                <Input placeholder='Send to' onChange={(e)=>setSendTo(e.target.value)} value={sendTo}/>
                                
                                <Button isLoading={processing} disabled={(!ethers.utils.isAddress(sendTo))} onClick={send}>Send</Button>
                                
                            </InputGroup>
                            
                            
                        </div>
                    </>
                    }
                </div>
                
                
            </HStack>
        </div>
        
    )
}

export default SendNFT